import React from 'react';
import { Link } from 'react-router-dom';
import { Cookie, ArrowLeft } from 'lucide-react';
import Logo from '../components/Logo';
import Header from '../components/Header';

const CookiesPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Header />

      <div className="pt-10 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          {/* Breadcrumb */}
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-gray-900">Accueil</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-900">Politique des cookies</span>
          </nav>

          {/* Header */}
          <div className="flex items-center space-x-4 mb-8">
            <div className="w-14 h-14 rounded-xl bg-orange-100 flex items-center justify-center">
              <Cookie className="w-7 h-7 text-orange-600" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Politique des cookies</h1>
              <p className="text-gray-500">Dernière mise à jour : 10 février 2026</p>
            </div>
          </div>

          {/* Content */}
          <div className="prose prose-gray max-w-none">
            <div className="bg-orange-50 border border-orange-100 rounded-xl p-6 mb-8">
              <p className="text-gray-700 m-0">
                Ce site utilise des cookies pour améliorer votre expérience de navigation. 
                En continuant à utiliser ce site, vous acceptez notre utilisation des cookies.
              </p>
            </div>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">1. Qu'est-ce qu'un cookie ?</h2>
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <p className="text-gray-700">
                  Un cookie est un petit fichier texte stocké sur votre appareil lorsque vous visitez un site web. 
                  Les cookies permettent au site de mémoriser vos actions et préférences (comme la connexion, la langue, 
                  la taille de police et autres préférences d'affichage) pendant une période donnée.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">2. Types de cookies utilisés</h2>
              <div className="space-y-4">
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2">Cookies essentiels</h3>
                  <p className="text-gray-600 text-sm">
                    Ces cookies sont nécessaires au fonctionnement du site. Ils permettent notamment de maintenir 
                    votre session de connexion et d'assurer la sécurité de vos transactions.
                  </p>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2">Cookies de performance</h3>
                  <p className="text-gray-600 text-sm">
                    Ces cookies nous aident à comprendre comment les visiteurs interagissent avec notre site en 
                    collectant des informations de manière anonyme.
                  </p>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-2">Cookies fonctionnels</h3>
                  <p className="text-gray-600 text-sm">
                    Ces cookies permettent de mémoriser vos préférences (langue, région) pour vous offrir une 
                    expérience personnalisée.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">3. Gestion des cookies</h2>
              <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                <p className="text-gray-700 mb-4">
                  Vous pouvez contrôler et/ou supprimer les cookies comme vous le souhaitez. Vous pouvez supprimer 
                  tous les cookies déjà présents sur votre ordinateur et paramétrer la plupart des navigateurs 
                  pour les bloquer.
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" 
                     className="bg-white p-3 rounded-lg border border-gray-200 text-center hover:border-gray-300 transition-colors">
                    <span className="text-sm font-medium text-gray-900">Chrome</span>
                  </a>
                  <a href="https://support.mozilla.org/fr/kb/cookies-informations-sites-enregistrent" target="_blank" rel="noopener noreferrer"
                     className="bg-white p-3 rounded-lg border border-gray-200 text-center hover:border-gray-300 transition-colors">
                    <span className="text-sm font-medium text-gray-900">Firefox</span>
                  </a>
                  <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer"
                     className="bg-white p-3 rounded-lg border border-gray-200 text-center hover:border-gray-300 transition-colors">
                    <span className="text-sm font-medium text-gray-900">Safari</span>
                  </a>
                  <a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge" target="_blank" rel="noopener noreferrer"
                     className="bg-white p-3 rounded-lg border border-gray-200 text-center hover:border-gray-300 transition-colors">
                    <span className="text-sm font-medium text-gray-900">Edge</span>
                  </a>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">4. Contact</h2>
              <div className="bg-orange-50 rounded-xl p-6 border border-orange-100">
                <p className="text-gray-700 mb-4">
                  Pour toute question concernant notre politique de cookies, contactez-nous :
                </p>
                <p className="text-gray-700"><strong>Email :</strong> privacy@alphaswapp.com</p>
              </div>
            </section>
          </div>

          {/* Navigation */}
          <div className="flex justify-between pt-8 border-t border-gray-200">
            <Link to="/" className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors">
              <ArrowLeft className="w-4 h-4" />
              <span>Retour à l'accueil</span>
            </Link>
            <div className="flex space-x-4">
              <Link to="/privacy" className="text-blue-600 hover:underline">Confidentialité</Link>
              <Link to="/agreement" className="text-blue-600 hover:underline">Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
